// extracted by mini-css-extract-plugin
export default {"store-wrapper":"CITR8","store-qr":"MDiQX","store-image":"vh1Z6","store-label":"k9TtG","stores-links":"o4xir"};